import { getFieldRules } from '../utils/formValidation';
import ruleSet from './ruleSet';
import { Credentials } from './formSelectOptions';

// Form configuration
const FORM_CONFIG = {
  id: 'surgeon-selector-form',
  defaultValues: {
    // Step 1: Personal Information
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    npiNumber: '',
    
    // Step 2: Specialty and Credentials
    credentials: [],
    ageOfPatients: [],
    specialties: [],
    
    // Facility Information
    facilitySearch: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    phoneNumber: '',
    facilityWebAddress: '',
    procedures: [],
    
    // Agreements
    receiveUpdates: false,
    agreeToTerms: false,
    agreeToSubmission: false
  },
  
  sections: {
    personalInfo: {
      id: 'personal-info-section',
      title: 'Personal Information',
      errorId: 'personal-info-error'
    },
    specialty: {
      id: 'specialty-section',
      title: 'Specialty and Credentials',
      errorId: 'specialty-error'
    },
    facility: {
      id: 'facility-section',
      title: 'Facility Information',
      errorId: 'facility-error'
    },
    agreement: {
      id: 'agreement-section',
      title: 'Agreements',
      errorId: 'agreement-error'
    }
  },

  analytics: {
    trackEvents: [],
    category: ''
  }
};

// Add helper function for form-specific rules
export const getFormFieldRules = (fieldName) => {
  return getFieldRules(fieldName, ruleSet, {
    credentials: Credentials,
    formKey: 'form_surgeon_selector'
  });
};

export default FORM_CONFIG; 